'use client';
import { Link } from '@/i18n/routing';
import LanguageSelect from "./menu";
import { useTranslations } from 'next-intl';
import { useLocale } from 'next-intl';





export default function NavBar() {
 
  const l = useLocale();
  const th = useTranslations('Padel-Master-The-Game-Home-header');


  return (
    <header className="absolute top-0 left-0 w-full z-50  text-b ">
      <nav
        className="flex justify-between items-center py-2  mt-4 px-5 gap-4 mx-2  lg:mx-24  border rounded-xl bg-a bg-opacity-90 backdrop-filter backdrop-blur-sm"
        aria-label="Global"
      >
        
        <Link href={"/"}>
          <h2 className="uppercase text-xl lg:text-2xl font-extrabold ">
            {th("logo")}
          </h2>
        </Link>
        
<LanguageSelect/>
      </nav>
    </header>
  );
}



/** <div className="gap-4 flex flex-auto justify-end ">
          {status === "authenticated" ? (
            <Link href="/account" rel="preload">
              <FiUser size={24} className="hover:text-bl" />
            </Link>
          ) : (
            <LoginButton />
          )}
        </div> */